import React, { useEffect } from 'react';
import { Card, Form, Row, Col, InputGroup, Badge } from 'react-bootstrap';
import { FaCalculator, FaCheck, FaTimes } from 'react-icons/fa';
import { colors } from '../../../../../utils/Colors';

const BillDetails = ({
  formData,
  handleBillDetailsChange,
  calculateFoodBill,
  calculateGovtTax,
  calculatePerHead,
  formatCurrency,
  setFormData
}) => {
  

  const handleTaxInclusionToggle = (e) => {
    const isIncluded = e.target.checked;
    
    setFormData(prev => ({
      ...prev,
      billDetails: {
        ...prev.billDetails,
        includeTax: isIncluded
      }
    }));
  };

 
  const calculateSubtotal = () => {
    const foodBill = calculateFoodBill();
    const djMusic = parseInt(formData.billDetails.djMusic) || 0;
    const serviceCharges = parseInt(formData.billDetails.serviceCharges) || 0;
    const hallRent = parseInt(formData.billDetails.hallRent) || 0;
    const bwdStage = parseInt(formData.billDetails.bwdStage) || 0;
    const acCharges = parseInt(formData.billDetails.acCharges) || 0;
    const heaterCharges = parseInt(formData.billDetails.heaterCharges) || 0;
    const ladiesWaiter = parseInt(formData.billDetails.ladiesWaiter) || 0;
    const otherCharges = parseInt(formData.billDetails.otherCharges) || 0;
    
    return foodBill + djMusic + serviceCharges + hallRent + bwdStage +
      acCharges + heaterCharges + ladiesWaiter + otherCharges;
  };

  
  const calculateTotalAmount = () => {
  const subtotal = calculateSubtotal();
  const rawTax = calculateGovtTax(); // sirf display
  const isTaxIncluded = formData.billDetails.includeTax === true;

  const effectiveTax = isTaxIncluded ? rawTax : 0;

  return subtotal + effectiveTax;
};



  const calculateRemainingAmount = () => {
    const totalAmount = calculateTotalAmount();
    const advancePayment = parseInt(formData.eventDetails.advancePayment) || 0;
    return totalAmount - advancePayment;
  };


useEffect(() => {
  const subtotal = calculateSubtotal();
  const rawTax = calculateGovtTax();
  const isTaxIncluded = formData.billDetails.includeTax === true;

  const effectiveTax = isTaxIncluded ? rawTax : 0;
  const total = subtotal + effectiveTax;

  const advance = parseInt(formData.eventDetails.advancePayment) || 0;

  setFormData(prev => ({
    ...prev,
    billDetails: {
      ...prev.billDetails,
      foodBill: calculateFoodBill(),
      govtTax: rawTax,          // 🔹 sirf show ke liye
      totalAmount: total,       // 🔥 tax sirf include pe
      remainingAmount: total - advance
    }
  }));
}, [
  formData.billDetails.djMusic,
  formData.billDetails.serviceCharges,
  formData.billDetails.hallRent,
  formData.billDetails.bwdStage,
  formData.billDetails.acCharges,
  formData.billDetails.heaterCharges,
  formData.billDetails.ladiesWaiter,
  formData.billDetails.otherCharges,
  formData.billDetails.includeTax,
  formData.eventDetails.advancePayment,
  JSON.stringify(formData.menu)
]);


  // Get current tax inclusion status
  const isTaxIncluded = formData.billDetails.includeTax === true;

  return (
    <Card className="mb-4 border-0 shadow-sm">
      <Card.Header className="text-white d-flex align-items-center" style={{ backgroundColor: colors.TABLE_HEADERS }}>
        <div className="p-2 me-3 bg-white bg-opacity-25 rounded-circle">
          <FaCalculator size={20} />
        </div>
        <h5 className="mb-0">Bill Details & Charges</h5>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col md={6}>
            {[
              { label: 'DJ/Music', name: 'djMusic' },
              { label: 'Service Charges', name: 'serviceCharges' },
              { label: 'Hall Rent', name: 'hallRent' },
              { label: 'BWD Stage', name: 'bwdStage' },
              { label: 'AC Charges', name: 'acCharges' },
            ].map((item, index) => (
              <Form.Group key={index} className="mb-3">
                <Form.Label>{item.label} (PKR)</Form.Label>
                <InputGroup>
                  <InputGroup.Text>Rs</InputGroup.Text>
                  <Form.Control
                    type="number"
                    name={item.name}
                    value={formData.billDetails[item.name] || ''}
                    onChange={handleBillDetailsChange}
                    placeholder="0"
                    min="0"
                  />
                </InputGroup>
              </Form.Group>
            ))}
          </Col>
          <Col md={6}>
            {[
              { label: 'Heater Charges', name: 'heaterCharges' },
              { label: 'Ladies Waiter', name: 'ladiesWaiter' },
              { label: 'Other Charges', name: 'otherCharges' },
            ].map((item, index) => (
              <Form.Group key={index} className="mb-3">
                <Form.Label>{item.label} (PKR)</Form.Label>
                <InputGroup>
                  <InputGroup.Text>Rs</InputGroup.Text>
                  <Form.Control
                    type="number"
                    name={item.name}
                    value={formData.billDetails[item.name] || ''}
                    onChange={handleBillDetailsChange}
                    placeholder="0"
                    min="0"
                  />
                </InputGroup>
              </Form.Group>
            ))}

            <Form.Group className="mb-3">
              <Form.Label className="fw-bold">Food Bill (PKR)</Form.Label>
              <InputGroup>
                <InputGroup.Text>Rs</InputGroup.Text>
                <Form.Control
                  type="number"
                  value={calculateFoodBill()}
                  readOnly
                  className="fw-bold border-primary"
                />
              </InputGroup>
              <Form.Text className="text-muted">
                Calculated from menu selection
              </Form.Text>
            </Form.Group>

            <Form.Group className="mb-3">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <Form.Label className="fw-bold mb-0">GOVT Tax 5% (PKR)</Form.Label>
                <div className="d-flex align-items-center">
                  <Form.Check
                    type="switch"
                    id="tax-include-switch"
                    label={
                      <span className="small">
                        {isTaxIncluded ? (
                          <Badge bg="success" className="ms-2">
                            <FaCheck className="me-1" /> Included
                          </Badge>
                        ) : (
                          <Badge bg="danger" className="ms-2">
                            <FaTimes className="me-1" /> Excluded
                          </Badge>
                        )}
                      </span>
                    }
                    checked={isTaxIncluded}
                    onChange={handleTaxInclusionToggle}
                    className="mb-0"
                  />
                </div>
              </div>
              <InputGroup>
                <InputGroup.Text>Rs</InputGroup.Text>
                <Form.Control
                  type="number"
                  value={calculateGovtTax()}
                  readOnly
                  className={`fw-bold ${isTaxIncluded ? 'border-success' : 'border-danger'}`}
                  style={{
                    backgroundColor: isTaxIncluded ? '#d4edda' : '#f8d7da',
                    color: isTaxIncluded ? '#155724' : '#721c24'
                  }}
                />
                <InputGroup.Text>
                  {isTaxIncluded ? (
                    <span className="text-success">
                      <FaCheck /> Included
                    </span>
                  ) : (
                    <span className="text-danger">
                      <FaTimes /> Excluded
                    </span>
                  )}
                </InputGroup.Text>
              </InputGroup>
              <Form.Text className={`${isTaxIncluded ? 'text-success' : 'text-danger'}`}>
                {isTaxIncluded 
                  ? 'Tax INCLUDED in total bill (5% of Food Bill)'
                  : 'Tax EXCLUDED from total bill'
                }
              </Form.Text>
            </Form.Group>
          </Col>
        </Row>

        {/* Summary Section */}
        <Card className="border-primary mt-4">
          <Card.Body>
            <Row>
              <Col md={4} className="text-center">
                <h6 className="text-muted">Per Head Amount</h6>
                <h3 className="text-primary fw-bold">{formatCurrency(calculatePerHead())}</h3>
                <small className="text-muted">Food Bill ÷ Persons</small>
              </Col>
              <Col md={4} className="text-center border-start border-end">
                <h6 className="text-muted">Service Type</h6>
                <div className="d-flex justify-content-center mt-2">
                  <Form.Check
                    type="radio"
                    name="serviceType"
                    label="Table"
                    value="Table"
                    checked={formData.serviceType === 'Table'}
                    onChange={(e) => setFormData(prev => ({
                      ...prev,
                      serviceType: e.target.value
                    }))}
                    className="me-3"
                  />
                  <Form.Check
                    type="radio"
                    name="serviceType"
                    label="Buffet"
                    value="Buffet"
                    checked={formData.serviceType === 'Buffet'}
                    onChange={(e) => setFormData(prev => ({
                      ...prev,
                      serviceType: e.target.value
                    }))}
                  />
                </div>
              </Col>
              <Col md={4} className="text-center">
                <h6 className="text-muted">Total Bill</h6>
                <h3 className="text-success fw-bold">
                  {formatCurrency(calculateTotalAmount())}
                </h3>
                <small className={isTaxIncluded ? 'text-success' : 'text-danger'}>
                  {isTaxIncluded ? '(Tax Included)' : '(Tax Excluded)'}
                </small>
              </Col>
            </Row>

            <div className="mt-4 border-top pt-3">
              <Row>
                <Col md={6}>
                  <div className="d-flex justify-content-between mb-2">
                    <span>Subtotal:</span>
                    <span className="fw-bold">{formatCurrency(calculateSubtotal())}</span>
                  </div>
                  {isTaxIncluded ? (
                    <div className="d-flex justify-content-between text-success mb-2">
                      <span>GOVT Tax 5% (Included):</span>
                      <span>+{formatCurrency(calculateGovtTax())}</span>
                    </div>
                  ) : (
                    <div className="d-flex justify-content-between text-danger mb-2">
                      <span>GOVT Tax 5% (Excluded):</span>
                      <span className="text-decoration-line-through">{formatCurrency(calculateGovtTax())}</span>
                    </div>
                  )}
                  <div className="d-flex justify-content-between border-top pt-2 mb-2">
                    <span className="fw-bold">Total Bill:</span>
                    <span className="fw-bold text-success">{formatCurrency(calculateTotalAmount())}</span>
                  </div>
                  <div className="d-flex justify-content-between text-primary">
                    <span>Advance Paid:</span>
                    <span>-{formatCurrency(formData.eventDetails.advancePayment || 0)}</span>
                  </div>
                </Col>
                <Col md={6} className="text-end">
                  <h5 className={`fw-bold ${calculateRemainingAmount() > 0 ? 'text-danger' : 'text-success'}`}>
                    Remaining: {formatCurrency(calculateRemainingAmount())}
                  </h5>
                  {calculateRemainingAmount() > 0 && (
                    <small className="text-muted d-block mb-2">
                      To be paid before event
                    </small>
                  )}
                  {!isTaxIncluded && (
                    <div className="alert alert-warning p-2 mt-2">
                      <small>
                        <strong><FaTimes className="me-1" />Important:</strong> 
                        Tax of {formatCurrency(calculateGovtTax())} is NOT included.
                        <br />
                        <strong>Final bill with tax:</strong> {formatCurrency(calculateSubtotal() + calculateGovtTax())}
                      </small>
                    </div>
                  )}
                </Col>
              </Row>
            </div>

            {/* Tax Summary Alert */}
            <div className={`mt-3 p-3 ${isTaxIncluded ? 'alert alert-success' : 'alert alert-danger'}`}>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <strong>Tax Status:</strong>
                  <span className="ms-2">
                    {isTaxIncluded 
                      ? `✓ Tax ${formatCurrency(calculateGovtTax())} INCLUDED → Total: ${formatCurrency(calculateTotalAmount())}`
                      : `✗ Tax ${formatCurrency(calculateGovtTax())} EXCLUDED → Current Total: ${formatCurrency(calculateTotalAmount())} (without tax)`
                    }
                  </span>
                </div>
                <Form.Check
                  type="switch"
                  id="tax-summary-switch"
                  checked={isTaxIncluded}
                  onChange={handleTaxInclusionToggle}
                  label={isTaxIncluded ? "Include" : "Exclude"}
                />
              </div>
            </div>
          </Card.Body>
        </Card>
      </Card.Body>
    </Card>
  );
};

export default BillDetails;